export default __webpack_public_path__ + "static/media/action.7134d072.png";